import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Hero from './components/Hero';
import FabricIntro from './components/FabricIntro';
import ColourSwatches from './components/ColourSwatches';
import FabricFeaturesGrid from './components/FabricFeaturesGrid';
import BottomCTA from './components/BottomCTA';
import CertificationBanner from '@/components/feature/CertificationBanner';
import { productJsonLd } from '@/components/feature/ProductJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const jsonLd = productJsonLd({
  name: 'Fabric & Colours — Premium Tent Materials | Pop Pro Tents',
  description: 'Explore our range of premium stretch tent fabrics and colour options. Waterproof, UV-resistant, fire-rated materials available in multiple shades. Custom colour matching available for bespoke tent orders.',
  url: `${siteUrl}/products/fabric-and-colours`,
  category: 'Tent Fabric & Materials',
});

export default function FabricAndColoursPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <FabricIntro />
        <CertificationBanner />
        <ColourSwatches />
        <FabricFeaturesGrid />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}